// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".likefolder-action-button-name.disabled[data-v-a0838cc6]{color:#9c9c9c}.likefolder-action-button.disabled[data-v-a0838cc6]{cursor:not-allowed}.likefolder-action-button-icon[data-v-a0838cc6]{transition:background-color ease 0.2s}.likefolder-action-button-icon[data-v-a0838cc6]:hover{box-shadow:inset 0 0 100px 100px rgba(255,255,255,0.2)}\n", ""]);
// Exports
module.exports = exports;
